import React from 'react';
import ContentLayout from 'src/components/ContentLayout';
import Title from './Title';
import MerchantTable from './MerchantTable';

const Merchants: React.FC = () => (
  <ContentLayout size="fullScreen">
    <Title />
    <MerchantTable />
  </ContentLayout>
);

export default Merchants;
